import React, { useEffect, useState } from 'react';
import { pdfjs, Document, Page } from 'react-pdf';
import 'react-pdf/dist/Page/AnnotationLayer.css';
import 'react-pdf/dist/Page/TextLayer.css';

// pdfjs.GlobalWorkerOptions.workerSrc = new URL(
//     'pdfjs-dist/legacy/build/pdf.worker.min.js',
//     import.meta.url,
// ).toString();
pdfjs.GlobalWorkerOptions.workerSrc = `//cdnjs.cloudflare.com/ajax/libs/pdf.js/${pdfjs.version}/pdf.worker.min.js`;
interface props {
    source: string;
    renderAnnotationLayer: boolean;
    renderTextLayer: boolean;
    width?: number;
}

export const PdfView =  ({source, renderAnnotationLayer = false, renderTextLayer = false, width = 480} : props) => {
    const [numPages, setNumPages] = useState<number>();
    function onDocumentLoadSuccess({ numPages }: { numPages: number }): void {
        setNumPages(numPages);
    }
    return (
        <Document file={source} onLoadSuccess={onDocumentLoadSuccess}>
        {Array.from(new Array(numPages), (el, index) => (
            <Page
                key={`page_${index + 1}`}
                pageNumber={index + 1}
                renderAnnotationLayer={renderAnnotationLayer}
                renderTextLayer={renderTextLayer}
                width={width}
            />
            ))}
        </Document>
    );
};
